import React, { useState } from 'react'
import Webcam from "react-webcam";
import { Dialog, DialogContent } from '@mui/material';
import api from "../../../api/api";

function ComplaintImageCapture({callback}) {

    const [facingMode,setFacingMode] = useState("user")
    const [imageUri,setImageUri] = useState(null); 
    const swicthCamera = () =>{
        if(facingMode == "user"){
            setFacingMode("environment")
        }
        if(facingMode == "environment"){
            setFacingMode("user")
        }
    }
    const videoConstraints = {
        width: 800,
        height: 800,
        facingMode: facingMode,
    };

    const [dialogStatus,setDialogStatus] = useState(false);
    const handleClose = () =>{
        setDialogStatus(false);
    }

    const  DataURIToBlob = (dataURI) => {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)

        return new Blob([ia], { type: mimeString })
    }



    /*
    const uploadVisitorImage = (image) => {
        let data = new FormData();
        data.append('tmpFile',DataURIToBlob(image));
        data.append('visitorId',visitorDetails.id)
        api.post("upload/visitor/image/local",data,  
            {headers: {'Content-Type': 'multipart/form-data'}}
        ).then( (res)=>{
            //console.log("here in success");
            //console.log(res.data);
            getVisitorDetails();
            setDialogStatus(false);
        }).catch( (error) => {
            //console.log("here in error");
            
            //console.log(error);
        })
    }
    */

    const uploadFile = (e) =>{
        console.log(e.target.files[0]);
        setImageUri(URL.createObjectURL(e.target.files[0]))
        callback(e.target.files[0])
    }

    return (
    <>
        <div className="row">
            <div className="col-md-12 text-center">
                {imageUri && <img src={imageUri} className='' style={{height:200,width:200}} /> }
            </div>
            <div className="col-md-12 text-center">
                <button type="button" className="btn btn-primary mt-2" onClick={()=>setDialogStatus(true)}>Open Camera</button>
                <input type='file'
                    onChange={ (e)=>{ uploadFile(e) } } 
                    accept="image/png, image/gif, image/jpeg"
                    id="complaintImageFile"
                    className='d-none'
                ></input>
                <label htmlFor='complaintImageFile' className='btn btn-primary mx-2 mt-2'>Upload From Gallery</label>
            </div>
        </div>
        
        <Dialog
            open={dialogStatus}
            keepMounted
            onClose={handleClose}
            fullScreen={true}
        >
            <DialogContent style={{padding:0}}>
            <div className="row">
                <div className="col-md-12 text-center">
                    {dialogStatus == true &&
                        <Webcam
                            audio={false}
                            height={350}
                            screenshotFormat="image/jpeg"
                            width={350}
                            videoConstraints={videoConstraints}
                        >
                            {({ getScreenshot }) => (
                                <><br/>
                                <button
                                    className="btn btn-primary m-2"
                                    onClick={() => {
                                        let imageSrc = getScreenshot();
                                        callback(DataURIToBlob(imageSrc))
                                        setImageUri(imageSrc)
                                        setDialogStatus(false);
                                        //uploadVisitorImage(imageSrc);
                                    }}
                                
                                >
                                    Capture photo
                                </button>
                                <button type="button" onClick={swicthCamera} className="btn btn-dark m-2">Switch Camera</button>
                                <button type="button" onClick={handleClose} className="btn btn-outline-primary m-2">Cancel</button>
                                </>
                            )}
                        </Webcam>
                    }
                </div>
            </div>
            </DialogContent>
        </Dialog>

        
    

    </>
  )
}

export default ComplaintImageCapture
